var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96875 0H1.40625C0.629883 0 0 0.629883 0 1.40625V13.5938C0 14.3701 0.629883 15 1.40625 15H7.96875C8.74512 15 9.375 14.3701 9.375 13.5938V1.40625C9.375 0.629883 8.74512 0 7.96875 0ZM4.6875 14.0625C4.16895 14.0625 3.75 13.6436 3.75 13.125C3.75 12.6064 4.16895 12.1875 4.6875 12.1875C5.20605 12.1875 5.625 12.6064 5.625 13.125C5.625 13.6436 5.20605 14.0625 4.6875 14.0625ZM7.96875 10.8984C7.96875 11.0918 7.81055 11.25 7.61719 11.25H1.75781C1.56445 11.25 1.40625 11.0918 1.40625 10.8984V1.75781C1.40625 1.56445 1.56445 1.40625 1.75781 1.40625H7.61719C7.81055 1.40625 7.96875 1.56445 7.96875 1.75781V10.8984Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.15083aee583efa0ef36e06b670c1d44a.svg";
export { ForwardRef as ReactComponent };